import { t } from 'i18next';
import React from 'react';
import { Link } from 'react-router-dom';
import { OnChangeValue } from 'react-select';
import { CiCirclePlus } from 'react-icons/ci';

import MissionControlLayersFilters from './MissionControlLayersFilters/MissionControlLayersFilters';

import classes from './MissionControlHead.module.scss';
import { MSelectChangeData, MSelectOption } from 'views/MSelect/MSelect.model';
import { ConnectorPowerLabel, ConnectorTypeLabel } from 'utils/enums/chargingType';

type Props = {
  connectorTypeFilters: MSelectOption<null, ConnectorTypeLabel>[];
  generalFilterValue: string;
  dateFilters: {
    startDate: moment.Moment | null;
    endDate: moment.Moment | null;
  };
  powerTypeFilters: MSelectOption<null, ConnectorPowerLabel>[];
  isBuildScenarioPermitted: boolean;
  onConnectorTypeFilterChange: (value: OnChangeValue<MSelectChangeData<null, ConnectorTypeLabel>, true>) => void;
  onGeneralFilterChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onResetDate?: () => void;
  onDateFilterChange: (startDate: moment.Moment | null, endDate: moment.Moment | null) => void;
  onClearGeneralFilter: () => void;
  onPowerTypeFilterChange: (value: OnChangeValue<MSelectChangeData<null, ConnectorPowerLabel>, true>) => void;
};

const MissionControlHeadView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className={classes['headWrapper']}>
      <div className={classes['head']}>
        <div className={classes['titleWrapper']}>
          <h1 className={classes['title']} data-testid="mission-control-title">{t('missionControl.header.title')}</h1>

          {props.isBuildScenarioPermitted ? (
            <div className={classes['buttonWrrper']}>
              <Link to="/sites/scenario">
                <button className={classes['button']}>
                  <div className={classes['buttonText']}>{t('missionControl.header.createScenario')}</div>
                  <CiCirclePlus />
                </button>
              </Link>
            </div>
          ) : null}
        </div>
        <MissionControlLayersFilters
          connectorTypeFilters={props.connectorTypeFilters}
          onConnectorTypeFilterChange={props.onConnectorTypeFilterChange}
          onGeneralFilterChange={props.onGeneralFilterChange}
          generalFilterValue={props.generalFilterValue}
          onResetDate={props.onResetDate}
          dateFilters={props.dateFilters}
          onDateFilterChange={props.onDateFilterChange}
          onClearGeneralFilter={props.onClearGeneralFilter}
          onPowerTypeFilterChange={props.onPowerTypeFilterChange}
          powerTypeFilters={props.powerTypeFilters}
        ></MissionControlLayersFilters>
      </div>
    </div>
  );
};

MissionControlHeadView.displayName = 'MissionControlHeadView';
MissionControlHeadView.defaultProps = {};

export default MissionControlHeadView;
